import infoIcon from '@assets/icons/infoCircle.svg'
import rightArrow from '@assets/icons/rightArrow.svg'
import { Tooltip } from 'antd'
import Image from 'next/image'
import { useRouter } from 'next/router'
import styled from 'styled-components'
import { useHotPools } from '../../hooks/rockpool/useHotPools'
import { Collection } from '../../types/CollectionTypes'
import CardGrid from '../design-system/CardGrid'
import CardLoader from '../design-system/CardLoader'
import RockPoolCard from '../shared/cards/RockPoolCard'
import { NFTCollectionCard } from './collections/cards/NFTCollectionCard'

export interface ListPoolsProps {
  topCollections: Collection[]
  chainId: number
}

export const ListPools = ({ topCollections, chainId }: ListPoolsProps) => {
  const route = useRouter()

  const { hotPools, hotPoolsLoading } = useHotPools(chainId)
  return (
    <Container>
      <ListItems>
        <h1>
          Hot pools
          <Tooltip title='Pools with the highest volume of participation.'>
            <Image layout='fixed' width={27} height={27} src={infoIcon} alt='Helping tip' />
          </Tooltip>
        </h1>

        <CardGrid
          data={hotPools.map(rockpoolItem => (
            <RockPoolCard key={`card-rockpool-${rockpoolItem.id}`} item={rockpoolItem} isStatusBar />
          ))}
          loader={<CardLoader />}
          hasMore={hotPoolsLoading}
          loadMore={() => null}
        />
        <button type='button' onClick={() => route.push(`/rockpool/${chainId}`)}>
          See all Pools
          <Image layout='fixed' width={13} height={13} src={rightArrow} alt='Helping tip' />
        </button>
      </ListItems>
      {topCollections.length > 0 && (
        <ListItems>
          <h1>
            Top Collections
            <Tooltip title='Most popular collections listed on OpenSea.'>
              <Image layout='fixed' width={27} height={27} src={infoIcon} alt='Helping tip' />
            </Tooltip>
          </h1>
          <CardGrid
            data={topCollections.map(collection => (
              <NFTCollectionCard key={`card-collection-${collection.slug}`} collection={collection} />
            ))}
            hasMore={false}
            loadMore={() => null}
            loader={null}
          />
          <button type='button' onClick={() => route.push(`/rockpool/${chainId}/collections`)}>
            See all Collections
            <Image layout='fixed' width={13} height={13} src={rightArrow} alt='Helping tip' />
          </button>
        </ListItems>
      )}
    </Container>
  )
}

export const { Container, ListItems } = {
  Container: styled.div`
    width: 100%;
    padding: 0px 24px;

    margin: 0 auto;

    display: flex;
    flex-direction: column;
    gap: 48px;

    margin-bottom: 24px;

    @media (min-width: ${props => props.theme.viewport.desktop}) {
      max-width: 1680px;
    }
  `,
  ListItems: styled.section`
    display: flex;
    flex-direction: column;
    gap: 40px;

    > h1 {
      display: flex;
      align-items: center;
      text-align: center;
      gap: 18px;

      font-style: normal;
      font-weight: 300;
      font-size: 32px;
      line-height: 100%;
      color: ${props => props.theme.colors.black};

      @media (min-width: ${props => props.theme.viewport.desktop}) {
        font-size: 42px;
        line-height: 42px;
      }
    }

    > button {
      cursor: pointer;
      height: 48px;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      gap: 16px;

      color: ${props => props.theme.colors.black};

      background: transparent;

      border: 2px solid #226aed;
      box-sizing: border-box;
      border-radius: 800px;

      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 24px;

      @media (min-width: ${props => props.theme.viewport.tablet}) {
        width: fit-content;
        padding: 0px 24px;
        margin: 0 auto;
      }
    }
  `
}
